import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const purchasedTimesSRPSelector = createSelector(testTargetOffersSelector, offers => offers.purchasedTimesSRP || Empty.Object);

export { purchasedTimesSRPSelector };
